import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-aggregated-progress"
}
const _hoisted_2 = {
  key: 0,
  class: "table-aggregated-progress__header"
}
const _hoisted_3 = {
  key: 0,
  class: "table-aggregated-progress__title"
}
const _hoisted_4 = ["aria-valuenow", "aria-valuetext", "aria-label"]
const _hoisted_5 = { class: "table-aggregated-progress__track" }
const _hoisted_6 = {
  class: "table-aggregated-progress__text",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_ctx.getShowProgress)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.getShowHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.options.title)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.options.title), 1))
                : _createCommentVNode("", true),
              (_ctx.options.hintText)
                ? (_openBlock(), _createBlock(_component_Tooltip, {
                    key: 1,
                    class: "table-aggregated-progress__hint"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.options.hintText), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "table-aggregated-progress__bar",
          role: "progressbar",
          "aria-valuenow": _ctx.getProgressPercent,
          "aria-valuemin": 0,
          "aria-valuemax": 100,
          "aria-valuetext": _ctx.getProgressAriaText,
          "aria-label": _ctx.options.title
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "table-aggregated-progress__fill",
              style: _normalizeStyle({ transform: `scaleX(${_ctx.getProgressRatio})` })
            }, null, 4)
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getProgressPercent) + "%", 1)
        ], 8, _hoisted_4)
      ]))
    : _createCommentVNode("", true)
}